export class AsyncTask {

	constructor(taskName, taskFunc, callback, callbackArgs) {
		this.taskName = taskName;
		this.loading = false;
		this.taskFunc = taskFunc;
		this.totalStep = 0;
		this.percentage = 0;
		this.execIndex = 0;
		this.taskGroup = new Object();
		this.callback = callback;
		this.callbackArgs = callbackArgs;
	}

	setTaskName(taskName){
		this.taskName = taskName;
	}
	start() {
		this.loading = true;
		if (this.taskFunc){
			this.taskFunc.call();	
		}
		
		this.lastNotifyProgress = 0;
		this.curProgress = 0;
	}

	end() {
		this.loading = false;
		this.curProgress = 0;
		this.taskFunc = null;
		this.totalStep = 0;
		this.percentage = 0;
		this.execIndex = 0;
		this.taskGroup = new Object();
	}

	progress(step) {
		if (this.percentage == 100) return;
		if (step != undefined) {
			this.curProgress += step;
		} else {
			this.curProgress++;
		}
		var change = 100*(this.curProgress - this.lastNotifyProgress) / this.totalStep;
		var percentage = parseInt(100 * this.curProgress / this.totalStep);
		if (change > 10){
			this.percentage = percentage;	
			this.lastNotifyProgress = this.curProgress;
	
		}		
	}

	addTaskGroup(taskName, taskGroupName, funcArray) {
		this.totalStep++;
		if (this.taskGroup[taskGroupName] == undefined){
			this.taskGroup[taskGroupName] = new Object();
		}
		this.taskGroup[taskGroupName].funcArray = funcArray;
		this.taskGroup[taskGroupName].taskName = taskName;
	}

	checkJobDone(){
		var jobDone = true;
		for(var group in this.taskGroup){
			this.taskGroup[group].funcArray.map(item=>{
				if (!item.done){
					jobDone = false;
				}
			});
		}
		return jobDone;
	}

	notifyTaskComplete(taskGroupName, i){
		var that = this;
		var funcArray = this.taskGroup[taskGroupName].funcArray;
		funcArray[i].done = true;
		new Promise(function(resolve, reject) {
			that.progress();
			resolve();

		}).then(function() {
				if (that.checkJobDone()) {
					that.percentage = 100;
					that.totalStep = 0
					that.end();
						
					if (that.callback){
						that.callback.call(that.callbackArgs.scope, that.callbackArgs.arguments);
					}	
					return;
			}
		});


		
	}


	exec(taskGroupName, i) {
		this.taskName = this.taskGroup[taskGroupName].taskName;
		var funcArray = this.taskGroup[taskGroupName].funcArray;
		if (funcArray == undefined || funcArray.length == 0) {
			return;
		}
		var that = this;
		new Promise(function(resolve, reject) {
			var dataObj = funcArray[i].func.call(funcArray[i].scope, funcArray[i].param);
			if (funcArray[i].async){
				//异步调用
				funcArray[i].done = false;
			}
			else{
				funcArray[i].done = true;
				that.progress();
			}			
			resolve(dataObj);

		}).then(function(dataObj) {
			if (that.checkJobDone()) {
				that.percentage = 100;
				that.totalStep = 0
				setTimeout(function(){
					that.end();
					if(dataObj != undefined && dataObj.onJobDone != undefined){
						dataObj.onJobDone.call(funcArray[i].scope, dataObj);
					}
					if (that.callback){
						that.callback.call(that.callbackArgs.scope, that.callbackArgs.arguments);
					}	
				}, 1000);
				
				return;
			}
			setTimeout(function() {
				if (i == funcArray.length - 1) return;
				funcArray[i + 1].param = dataObj;
				that.exec(taskGroupName, i + 1);
			}, 0);

		});
	}

}


// WEBPACK FOOTER //
// ./src/plugins/js/task.js